module.exports = __webpack_public_path__ + "img/2-1.46459769.png";